module.exports = __webpack_public_path__ + "static/img/04.d5a9e61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/04.jpg
// module id = 3wSP
// module chunks = 0